import React, { useState } from 'react';

export default function ExperienceLevelStep({ onNext, onBack, data }) {
  const [selectedLevel, setSelectedLevel] = useState(data.experienceLevel || '');

  const experienceLevels = [
    {
      id: 'beginner',
      title: 'New to Crypto',
      description: "I'm just getting started.",
      color: '#10b981', // Green
    },
    {
      id: 'intermediate',
      title: 'Experienced',
      description: "I've made some trades, know the basics.",
      color: '#f59e0b', // Orange
    },
    {
      id: 'advanced',
      title: 'Pro',
      description: 'I actively trade and follow charts.',
      color: '#ef4444', // Red
    }
  ];

  const handleNext = () => {
    if (selectedLevel) {
      onNext({ experienceLevel: selectedLevel });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cdefs%3E%3Cpattern id='grid' width='10' height='10' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 10 0 L 0 0 0 10' fill='none' stroke='rgba(255,255,255,0.1)' stroke-width='0.5'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23grid)'/%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="flex-1 flex flex-col justify-start items-center px-4 pt-4 relative z-10">
        {/* Logo and Brand */}
        <div className="text-center mb-6 px-2 mt-2">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg">
            <span className="text-white font-bold text-lg">CI</span>
          </div>
          <h1 className="text-white text-lg font-semibold">CryptoIndicators.AI</h1>
        </div>

        {/* Main Question */}
        <div className="text-center mb-6 max-w-md px-2">
          <h2 className="text-2xl font-bold text-white mb-2">
            How familiar are you with crypto?
          </h2>
          <p className="text-gray-400 text-base">
            Let's personalize your crypto insights experience.
          </p>
        </div>

        {/* Experience Level Options */}
        <div className="w-full max-w-md space-y-3 mb-6 px-2">
          {experienceLevels.map((level) => (
            <button
              key={level.id}
              onClick={() => setSelectedLevel(level.id)}
              className={`w-full p-4 rounded-xl border-2 transition-all duration-300 ${
                selectedLevel === level.id
                  ? 'bg-gray-800 border-blue-500 shadow-lg shadow-blue-500/20'
                  : 'bg-gray-800/50 border-gray-700 hover:border-gray-600 hover:bg-gray-800/70'
              }`}
            >
              <div className="flex items-center space-x-4">
                {/* Colored Dot */}
                <div 
                  className={`w-4 h-4 rounded-full flex-shrink-0 ${
                    selectedLevel === level.id ? 'ring-2 ring-blue-500 ring-offset-2 ring-offset-gray-900' : ''
                  }`}
                  style={{ backgroundColor: level.color }}
                />
                
                {/* Text Content */}
                <div className="flex-1 text-left">
                  <h3 className="font-semibold text-white text-lg mb-1">
                    {level.title}
                  </h3>
                  <p className="text-gray-400 text-sm">
                    {level.description}
                  </p>
                </div>

                {/* Selection Indicator */}
                {selectedLevel === level.id && (
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>
            </button>
          ))}
        </div>

        {/* Next Button */}
        <div className="w-full max-w-md px-2">
          <button
            onClick={handleNext}
            disabled={!selectedLevel}
            className="w-full py-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
} 